import { camelKeys } from '@tencent/ark-utils/lib/object';
export function getRetCodeFromData(data) {
    return data.retcode || data.code || 0;
}
export function getMessageFromData(data) {
    return data.msg || data.message || data.retmsg || '';
}
export function normalizeResponse(response, needCamelKey) {
    var _a;
    if (needCamelKey === void 0) { needCamelKey = true; }
    var error = response.error, data = response.data;
    if (error) {
        return { error: error, resData: null };
    }
    // 如果 request 正常返回，则返回包装数据
    var resData = {
        data: needCamelKey && data ? camelKeys(data) : data,
        retcode: getRetCodeFromData(data),
        msg: getMessageFromData(data),
        cgicode: (_a = data.cgicode) !== null && _a !== void 0 ? _a : 0,
    };
    // 把data里默认的retcode、msg、cgicode干掉
    delete data.msg;
    delete data.message;
    delete data.retcode;
    delete data.code;
    delete data.cgicode;
    delete data.ret;
    return {
        resData: resData,
    };
}
